












import { Component, Vue } from "vue-property-decorator";
import Banner from "@/components/Banner/Banner";
import ProductListContainer from '@/components/ProductListContainer/ProductListContainer';
import CatNav from '@/components/CatNav/CatNav';

@Component({
  components: {
    Banner,
    ProductListContainer,
    CatNav
  }
})
export default class Home extends Vue {
  initCount = 0
}
